import { useEffect } from 'react'

import { selectors } from '@sketch/constants'

export default function useScrollReset() {
  useEffect(() => {
    const scrollingContainer = document.querySelector(
      selectors.contentScrollable
    )

    if (scrollingContainer) {
      scrollingContainer.scrollTop = 0
    }
  }, [])

  return
}
